<template>
    <div class="page">
        <div class="banner">
            <div class="content">
                <div class="title">{{ L('活动报名') }}</div>
                <div class="subtitle">Activity Registration</div>
                <div class="name">
                    {{ this.name }}
                </div>
            </div>
      
            <svg class="bg" viewBox="0 0 400 300" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M30.11 252.755h344.565" stroke="#000" stroke-width=".53" stroke-miterlimit="10"/><path opacity=".46" d="M311.69 198.5c-10.035-3.92-6-32.895 2.5-46.5 31.61-50.755 5.61-82.5-21.63-85.885-42.035-5.23-72.905 30.61-121.785 52.385-17.12 7.635-32.09 3.64-66.09 7.685-66.5 7.925-54.355 77.03-2.8 97.715 39.77 15.96 19.78 17.945 27 28.355 13.405 0 26.815-.07 40.215.255a.497.497 0 0 1 .53-.455c5.88 0 11.75.325 17.625.43a.555.555 0 0 1 .525-.72h93.88c22.11-11.695 49-2.135 62-10.305 21.135-13.225-.745-30.73-31.97-42.96Z" fill="#C2D3F9"/><path d="M307.31 112.655H146.02c-5.99 0-10.845 4.856-10.845 10.845v108.12c0 5.99 4.855 10.845 10.845 10.845h161.29c5.989 0 10.845-4.855 10.845-10.845V123.5c0-5.989-4.856-10.845-10.845-10.845Z" fill="#A1BEF7" style="mix-blend-mode:multiply" opacity=".87"/><path d="M295.625 102.29H136.75c-5.52 0-9.995 4.475-9.995 9.995v109.82c0 5.52 4.475 9.995 9.995 9.995h158.875c5.52 0 9.995-4.475 9.995-9.995v-109.82c0-5.52-4.475-9.995-9.995-9.995Z" fill="#F5F8FE" stroke="#231815" stroke-width=".335" stroke-miterlimit="10"/><path d="M214.69 183.515h-63.855a4.72 4.72 0 0 0-4.72 4.72v26.68a4.72 4.72 0 0 0 4.72 4.72h63.855a4.72 4.72 0 0 0 4.72-4.72v-26.68a4.72 4.72 0 0 0-4.72-4.72Z" fill="#8CACE2" style="mix-blend-mode:multiply" opacity=".38"/><path d="M208.365 174.86h-57.95a6.11 6.11 0 0 0-6.11 6.11v27.83a6.11 6.11 0 0 0 6.11 6.11h57.95a6.11 6.11 0 0 0 6.11-6.11v-27.83a6.11 6.11 0 0 0-6.11-6.11Z" fill="#fff" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M132.505 116.655H297.85" stroke="#231815" stroke-width=".395" stroke-miterlimit="10"/><path d="M210.245 131.905h-63.71a3.1 3.1 0 0 0-3.1 3.1v.005a3.1 3.1 0 0 0 3.1 3.1h63.71a3.1 3.1 0 0 0 3.1-3.1v-.005a3.1 3.1 0 0 0-3.1-3.1Z" fill="#49E5DB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M210.245 144.23h-63.71a3.1 3.1 0 0 0-3.1 3.1v.005a3.1 3.1 0 0 0 3.1 3.1h63.71a3.1 3.1 0 0 0 3.1-3.1v-.005a3.1 3.1 0 0 0-3.1-3.1ZM210.245 158.06h-63.71a3.1 3.1 0 0 0-3.1 3.1v.005a3.1 3.1 0 0 0 3.1 3.1h63.71a3.1 3.1 0 0 0 3.1-3.1v-.005a3.1 3.1 0 0 0-3.1-3.1Z" fill="#2F54EB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M171.89 186.27h-18.45a2.875 2.875 0 0 0-2.875 2.875v15.605a2.875 2.875 0 0 0 2.875 2.875h18.45a2.875 2.875 0 0 0 2.875-2.875v-15.605a2.875 2.875 0 0 0-2.875-2.875Z" fill="#49E5DB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M182.45 187.125h27.9M182.45 192.82h12.53M182.45 198.8h27.9M182.45 203.925h22.78M152.92 207.39l4.62-6.71 6.1 2.755 11.025-9.445" stroke="#000" stroke-width=".66" stroke-miterlimit="10"/><path d="M162.555 196.215a2.805 2.805 0 1 0 0-5.61 2.805 2.805 0 0 0 0 5.61Z" fill="#fff" stroke="#000" stroke-width=".66" stroke-miterlimit="10"/><path d="M305.715 116.6h-178.93V115c0-10.405 4.7-12.565 12-12.565h157.59a9.221 9.221 0 0 1 9.22 9l.12 5.165Z" fill="#2F54EB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M139.74 114.155a4.095 4.095 0 1 0 0-8.19 4.095 4.095 0 0 0 0 8.19Z" fill="#F66"/><path d="M152.225 114.155a4.095 4.095 0 1 0 0-8.19 4.095 4.095 0 0 0 0 8.19Z" fill="#F5F8FE" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M164.705 114.155a4.095 4.095 0 1 0 0-8.19 4.095 4.095 0 0 0 0 8.19Z" fill="#F8DC29"/><path d="M258.695 213.87c11.902 0 21.55-9.648 21.55-21.55 0-11.902-9.648-21.55-21.55-21.55-11.902 0-21.55 9.648-21.55 21.55 0 11.902 9.648 21.55 21.55 21.55Z" fill="#49E5DB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="m236.925 190.78 21 .845 15.905-14.72s-10.81-11.78-26.735-3.045c-10.51 5.75-10.17 16.92-10.17 16.92Z" fill="#fff" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M257.905 191.625V170.5s7.785-1.185 15.905 6.43l-15.905 14.695ZM295.335 173.69h-6.68v6.68h6.68v-6.68ZM295.335 200.72h-6.68v6.68h6.68v-6.68Z" fill="#2F54EB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M295.335 187.35h-6.68v6.68h6.68v-6.68Z" fill="#49E5DB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M241.435 133.35h49.91M241.435 139.875h24.115M241.435 146.4h49.91M241.435 152.925h37.835" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M337.99 124.33h-52.9a6.55 6.55 0 0 0-6.55 6.55v21.95a6.55 6.55 0 0 0 6.55 6.55h52.9a6.55 6.55 0 0 0 6.55-6.55v-21.95a6.55 6.55 0 0 0-6.55-6.55Z" fill="#2F54EB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M157.3 192.805H82.725a9.6 9.6 0 0 0-9.6 9.6v33.8a9.6 9.6 0 0 0 9.6 9.6H157.3a9.6 9.6 0 0 0 9.6-9.6v-33.8a9.6 9.6 0 0 0-9.6-9.6Z" fill="#2F54EB" stroke="#231815" stroke-width=".53" stroke-miterlimit="10"/><path d="m289.175 153.165 9.52-9.92 4.77 5.145 11.735-12.625 4.94 10.3 14.46-14.635" stroke="#fff" stroke-width=".59" stroke-miterlimit="10"/><path d="M333.78 136.29a.295.295 0 0 1-.225-.35l.95-4.415-4.4 1a.295.295 0 1 1-.13-.575l4.855-1.11a.297.297 0 0 1 .27.08.277.277 0 0 1 .08.27l-1.045 4.87a.383.383 0 0 1-.08.145.31.31 0 0 1-.275.085Z" fill="#fff"/><path d="M295.34 212.125c-.73.37-2.86.175-4.425-1.21s-3.465-.5-4.595.5-1.475 3.815.26 5.29.695 4.945-1.65 5.29c-2.345.345-4.855 2.255-4.335 4.425.52 2.17 1.56 3.12 4.165 3.035 2.605-.085 4 2.685 1.735 5.55-2.265 2.865-.61 4.42.17 4.945.78.525 2.95 1.73 5.12.085s4.595-.955 5.375 1.645c.78 2.6 2 4.25 4.08 3.82 2.08-.43 3.205-1.5 3.205-3.82s2-4.16 4.08-2.945c2.08 1.215 5.29 2.775 6.765.605 1.475-2.17.085-4.855-.955-5.725-1.04-.87-.61-4.25 1.735-4.42 2.345-.17 4.5-1.475 4.5-4.08s-2.605-3.38-4.86-3.38c-2.255 0-2.775-3.295-1.385-4.855 1.39-1.56 1.905-5.035 0-6.335-1.905-1.3-3.295-.17-5.29 1.04s-4.08 1.13-4.685-1.645c-.605-2.775-1.5-4.77-4-4.5-2.5.27-3.47 1.5-3.47 3.73s-1.02 2.695-1.54 2.955Z" fill="#F66" stroke="#231815" stroke-width=".55" stroke-miterlimit="10"/><path d="M300.96 230.575a5.155 5.155 0 1 0 0-10.31 5.155 5.155 0 0 0 0 10.31Z" fill="#fff" stroke="#231815" stroke-width=".58" stroke-miterlimit="10"/><path d="M204.485 81.74H192.7v11.785h11.785V81.74ZM192.76 81.795l11.5 11.5M192.715 93.415l11.71-11.575" stroke="#231815" stroke-width=".505" stroke-miterlimit="10"/><path d="M272.18 78.455h-40.335a6.425 6.425 0 0 0-6.425 6.425v.005a6.425 6.425 0 0 0 6.425 6.425h40.335a6.425 6.425 0 0 0 6.425-6.425v-.005a6.425 6.425 0 0 0-6.425-6.425Z" fill="#49E5DB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="M259.32 81.85h-40.335a6.425 6.425 0 0 0-6.425 6.425v.005a6.425 6.425 0 0 0 6.425 6.425h40.335a6.425 6.425 0 0 0 6.425-6.425v-.005a6.425 6.425 0 0 0-6.425-6.425Z" stroke="#231815" stroke-width=".505" stroke-miterlimit="10"/><path d="M91.715 204.17h-.005a2.64 2.64 0 0 0-2.64 2.64V237a2.64 2.64 0 0 0 2.64 2.64h.005a2.64 2.64 0 0 0 2.64-2.64v-30.19a2.64 2.64 0 0 0-2.64-2.64ZM111.375 204.17h-.005a2.64 2.64 0 0 0-2.64 2.64V237a2.64 2.64 0 0 0 2.64 2.64h.005a2.64 2.64 0 0 0 2.64-2.64v-30.19a2.64 2.64 0 0 0-2.64-2.64Z" fill="#fff"/><path d="M111.375 222.065h-.005a2.64 2.64 0 0 0-2.64 2.64V237a2.64 2.64 0 0 0 2.64 2.64h.005a2.64 2.64 0 0 0 2.64-2.64v-12.295a2.64 2.64 0 0 0-2.64-2.64ZM91.715 239.625a2.64 2.64 0 0 1-2.64-2.645v-7.54a2.634 2.634 0 0 1 4.51-1.858c.494.497.771 1.171.77 1.873V237a2.64 2.64 0 0 1-2.64 2.625Z" fill="#49E5DB"/><path d="M149.115 204.17h-.005a2.64 2.64 0 0 0-2.64 2.64V237a2.64 2.64 0 0 0 2.64 2.64h.005a2.64 2.64 0 0 0 2.64-2.64v-30.19a2.64 2.64 0 0 0-2.64-2.64Z" fill="#fff"/><path d="M149.115 239.64a2.646 2.646 0 0 1-2.645-2.64v-13.585a2.635 2.635 0 0 1 1.633-2.44 2.64 2.64 0 0 1 3.652 2.44V237a2.642 2.642 0 0 1-2.64 2.64Z" fill="#49E5DB"/><path d="M131.04 204.17h-.005a2.64 2.64 0 0 0-2.64 2.64V237a2.64 2.64 0 0 0 2.64 2.64h.005a2.64 2.64 0 0 0 2.64-2.64v-30.19a2.64 2.64 0 0 0-2.64-2.64Z" fill="#fff"/><path d="M131.035 239.64a2.645 2.645 0 0 1-2.64-2.64v-26.14a2.64 2.64 0 0 1 3.651-2.442 2.623 2.623 0 0 1 1.432 1.426c.133.321.202.664.202 1.011V237a2.647 2.647 0 0 1-2.645 2.64Z" fill="#49E5DB"/><path d="M77.225 171.26s-3.375-12.665 2.535-24.5 12.665-12.945 18.295-12.385c5.63.56 8.165 9.15 5.21 13.23-2.955 4.08-8.165 2.955-7.6-2.535.565-5.49 14.07-18.435 30.255-11.115" stroke="#231815" stroke-width=".4" stroke-miterlimit="10"/><path d="m66.11 169.315 10.46 1.035-3.75-9.805-2.615-.975-6.09 6.5s.75 2.66 1.995 3.245Z" fill="#fff" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="m37.5 147.21 28.63 22.105s-2.055-1.83-1.085-3.05c.97-1.22 3.47.305 3.47.305s-2.19-1.825-1.035-3.1c1.155-1.275 3.105.3 3.105.3s-1.275-1.885-.245-3c1.03-1.115 2.5-.245 2.5-.245S44.395 138.5 43.36 137.72c-1.035-.78-5.42-3.53-8.5.79-3.495 4.835 2.64 8.7 2.64 8.7Z" fill="#49E5DB" stroke="#231815" stroke-width=".44" stroke-miterlimit="10"/><path d="m48.275 146.21 18.585 14.12M45.165 148.92l19.265 14.685" stroke="#231815" stroke-width=".4" stroke-miterlimit="10"/><path d="M40.035 144.86a3.035 3.035 0 1 0 0-6.07 3.035 3.035 0 0 0 0 6.07Z" fill="#fff"/><path d="M37 141.825a3.034 3.034 0 1 1 6.07 0M72.335 169.925l2.57-3.545" stroke="#231815" stroke-width=".4" stroke-miterlimit="10"/></svg>
        </div>

        <a-skeleton v-if="loading || initialLoading" />

        <div class="wrapper" v-else>

            <section v-if="step=='login'" class="card">
                <div class="label">姓名</div>
                <a-input v-model="name" placeholder="请输入" />

                <div class="label">组别</div>
                <a-select v-model="gp" placeholder="请选择" style="width: 100%">
                    <a-select-option v-for="n in 20" :key="n" :value="n">{{ n }}</a-select-option>
                </a-select>

                <div class="footer">
                    <a-button type="primary"  @click="doLogin" :loading="saving">登录</a-button>
                </div>
            </section>

            <section v-if="step=='join'">
                <div v-for="(item) in filteredList" :key="item.label">

                    <div class="label">{{ item.label }}</div>

                    <div v-if="Array.isArray(item.options)" class="options-grid">
                        <div 
                            v-for="option in item.options" 
                            :key="option.label"
                            :class="['option-card', { 
                                'selected': item.selected === option.label || result.indexOf(option.label) > -1
                            }]"
                            @click="selectOption(item, option)">
                            <div class="option-header">
                                <div class="option-title">{{ option.label }}</div>
                                <div v-if="result.indexOf(option.label) > -1" class="registered-tag">已报名</div>
                            </div>
                            <div class="option-desc">{{ option.desc }}</div>
                            <div class="progress-bar-wrapper">
                                <div class="progress-bar">
                                    <div class="progress" :style="{width: getProgressWidth(option) + '%'}"></div>
                                </div>
                                <div class="suffix">
                                    <span class="value">{{ getProgressPercent(option) }}</span>
                                    <span class="unit">%</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="footer">
                        <a-button type="primary" block size="large" @click="submit(item)" :disabled="!item.open || result.indexOf(item.selected) > -1" :loading="saving">
                            {{ result.indexOf(item.selected) > -1 ? '已报名' : (item.open ? '确认报名' : '报名已关闭') }}
                        </a-button>
                    </div>

                </div>
                <div class="reg">
                    <a-button type="link" @click="doLogout">注销登录</a-button>
                </div>
            </section>
        </div>

    </div>
</template>

<script>
import { fetchConfig,signUp,fetchAnalysis } from '../../api/sign-up';

    export default {
        data() {
            return {
                name: '',
                gp: undefined,

                loading: false,
                list: [],

                filter: [],
                saving: false,

                result: [],
                step:'login',
                analysis: [],
                progressTimer: null,
                initialLoading: true
            }
        },

        mounted() {

            this.name = window.localStorage.getItem('name') || ''
            const gp = parseInt(window.localStorage.getItem('gp'));
            if (gp >= 1 && gp <= 20) {
                this.gp = gp;
            }

            if (this.name && this.gp) {
                const str = window.localStorage.getItem(this.userKey)
                if (str) {
                    this.result = JSON.parse(str);
                }
                this.step = 'join'
            }


            const { type } = this.$route.query;

            if (typeof type ==='string') {
                if (type.indexOf(',') > -1) {
                    this.filter.push(...type.split(','))
                } else {
                    this.filter.push(type)
                }
            }

            this.getList();
            this.startProgressTimer();
        },

        beforeDestroy() {
            this.stopProgressTimer();
        },

        computed: {
            userKey() {
                return `${this.gp}_${this.name}`;
            },

            filteredList() {
                if (this.filter.length > 0) {
                    return this.list.filter(item => this.filter.indexOf(item.type) > -1)
                } else {
                    return this.list
                }
            },
            
            analysisMap() {
                const map = {};
                this.analysis.forEach(ana => {
                    map[ana.class1] = ana;
                });
                return map;
            }
        },

        methods: {
            getProgressWidth(option) {
                if (!option.max || option.max === 0) return 0;
                const analysis = this.analysisMap[option.label];
                const current = analysis ? parseInt(analysis.cnt) : 0;
                return Math.min((current / option.max) * 100, 100);
            },

            getProgressPercent(option) {
                if (!option.max || option.max === 0) return 0;
                const analysis = this.analysisMap[option.label];
                const current = analysis ? parseInt(analysis.cnt) : 0;
                return Math.round((current / option.max) * 100);
            },

            async getProgressData() {
                try {
                    const res = await fetchAnalysis();
                    if (res && Array.isArray(res.list)) {
                        this.analysis = res.list;
                    }
                } catch (err) {
                    console.error('获取进度数据失败:', err);
                }
            },

            selectOption(item, option) {
                if (!item.open) return;
                
                // 如果已报名，不允许修改选择
                if (this.result.length > 0) return;

                console.log('selectOption', this.result)
                
                this.$set(item, 'selected', option.label);
            },

            startProgressTimer() {
                this.getProgressData();
                this.progressTimer = setInterval(() => {
                    this.getProgressData();
                }, 5000);
            },

            stopProgressTimer() {
                if (this.progressTimer) {
                    clearInterval(this.progressTimer);
                    this.progressTimer = null;
                }
            },
            doLogout() {
                window.localStorage.removeItem('name')
                window.localStorage.removeItem('gp')
                this.step = 'login'
                this.name = ''
                this.gp = undefined
                this.result = []
            },
            async getList() {
                this.loading = true;
                try {
                    const res = await fetchConfig();
                    console.log('res',res)
                    if (res && Array.isArray(res.list)) {
                        this.list = res.list.map(item => {

                            const obj = {...item}

                            if (Array.isArray(item.options)) {
                                item.options.forEach(option => {
                                    if (this.result.indexOf(option.label) > -1) {
                                        obj.selected = option.label;
                                    }
                                });
                            }

                            return obj;
                        })

                        this.getProgressData();
                    }

                    this.initialLoading = false;
                } finally {
                    this.loading = false;
                }
            },

            doLogin() {
                if (!this.name) {
                    this.$message.error('请输入姓名')
                    return;
                }

                if (!this.gp) {
                    this.$message.error('请选择组别')
                    return;
                }

                window.localStorage.setItem('name', this.name);
                window.localStorage.setItem('gp', this.gp);

                const str = window.localStorage.getItem(this.userKey);
                this.result = str ? JSON.parse(str) : [];

                this.step = 'join'

                this.$nextTick(() => {
                    this.$forceUpdate()
                })
            },

            async submit(item) {
                if (!this.name || !this.gp) {
                    this.$message.error('请先登录')
                    return;
                }

                if (item.selected) {

                    this.saving = true;

                    const data = new FormData();
                    data.append('name', this.name);
                    data.append('gp', this.gp);
                    data.append('class', item.type)
                    data.append('val', item.selected)
                    try {
                        const res = await signUp(data);
                        console.log('res',res)
                        if (res._status === 1) {
                            this.$message.success(res.info);
                            this.result.push(item.selected)
                            window.localStorage.setItem(this.userKey, JSON.stringify( this.result));
                        }
                    } finally {
                        this.saving = false;
                    }

                } else {
                    this.$message.error('请选择')
                }
            }
        }
    }
</script>

<style scoped>
    .page {
        background-color: #f0f0f0;
        min-height: 100vh;
    }

    .header {
        background-color: #034786;
        padding: 24px;
        color: #fff;
        font-weight: bold;
        font-size: 1.2em;
        text-align: center;
    }

    .banner {
        background-color: #034786;
        position: relative;
        border-bottom-left-radius: 24px;
        border-bottom-right-radius: 24px;
    }

    .bg {
        width: 50vw;
        margin-left: 50vw;
    }

    .content {
        position: absolute;
        top: 0;
        left: 24px;
        color: #fff;
    }
    .content .title {
        font-size: 1.2em;
        margin-top: 12px;
    }
    .content .subtitle {
        font-size: .9em;
    }
    .wrapper {
        padding: 16px;
    }
    .card {
        padding: 18px;
        margin-bottom: 18px;
        border-radius: 12px;
        background-color: #fff;
    }

    .label {
        margin-bottom: 8px;
        margin-top: 8px;
    }

    .option {
        line-height: 2;
    }

    .options-grid {
        display: flex;
        flex-direction: column;
        gap: 12px;
    }

    .option-card {
        padding: 16px;
        border: 2px solid #e8e8e8;
        border-radius: 8px;
        background-color: #fff;
        cursor: pointer;
        transition: all 0.3s ease;
    }

    .option-card:hover:not(.disabled) {
        border-color: #034786;
        box-shadow: 0 2px 8px rgba(3, 71, 134, 0.15);
    }

    .option-card.selected {
        border-color: #034786;
        background-color: #f0f4ff;
        box-shadow: 0 2px 8px rgba(3, 71, 134, 0.2);
    }

    .option-card.disabled {
        opacity: 0.6;
        cursor: not-allowed;
        background-color: #f5f5f5;
        pointer-events: none;
    }

    .option-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-bottom: 4px;
    }

    .option-title {
        font-weight: bold;
        color: #034786;
        flex: 1;
    }

    .registered-tag {
        background-color: #034786;
        color: white;
        font-size: 10px;
        padding: 2px 6px;
        border-radius: 4px;
        font-weight: normal;
        flex-shrink: 0;
        margin-left: 8px;
    }

    .option-desc {
        font-size: 12px;
        color: #666;
        line-height: 1.4;
        margin-bottom: 8px;
    }

    .progress-bar-wrapper {
        display: flex;
        align-items: center;
        margin-top: 8px;
    }

    .progress-bar {
        border-radius: 12px;
        background-color: #f0f0f0;
        flex: 1;
        height: 8px;
        margin-right: 8px;
        overflow: hidden;
    }

    .progress {
        background: linear-gradient(to right, #034786, #49a9ee);
        border-radius: 12px;
        height: 100%;
        transition: width 0.3s ease;
    }

    .suffix .value {
        font-size: 12px;
        font-weight: bold;
        color: #034786;
        margin-right: 1px;
    }

    .suffix .unit {
        font-size: 10px;
        color: #666;
    }

    .footer {
        margin-top: 16px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .reg {
        text-align: center;
        margin-top: 20px;
    }
    .desc {
        font-size:11px;
        word-break: break-word;
    }
    .name {
        margin-top: 20px;
        font-size:34px;
        display: flex;
        flex-direction: column;
    }
</style>